import { useEffect, useState } from 'react'

const DAYS = [
  { day: 1, sends: 50, label: '50/day' },
  { day: 7, sends: 1500, label: '1.5K/day' },
  { day: 14, sends: 5000, label: '5K/day' },
  { day: 28, sends: 25000, label: '25K/day' },
  { day: 42, sends: 50000, label: 'Full volume' },
] as const

const MAX_SENDS = 50000

export function WarmingTimeline() {
  const [activeDay, setActiveDay] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveDay((p) => (p + 1) % DAYS.length)
    }, 2000)
    return () => clearInterval(interval)
  }, [])

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      <div style={{ display: 'flex', alignItems: 'end', gap: 8, height: 120 }}>
        {DAYS.map((d, i) => (
          <div
            key={i}
            style={{
              flex: 1, display: 'flex', flexDirection: 'column',
              alignItems: 'center', gap: 6,
            }}
          >
            <span
              style={{
                fontFamily: "var(--oe-font-mono)", fontSize: 11,
                color: i <= activeDay ? '#FF6B00' : '#999',
                fontWeight: i === activeDay ? 700 : 400,
                transition: 'all 0.5s',
              }}
            >
              {d.label}
            </span>
            <div
              style={{
                width: '100%', borderRadius: 6,
                background: i <= activeDay
                  ? 'linear-gradient(180deg, #FF6B00, #FF9E4F)'
                  : '#EDE9E4',
                height: `${(d.sends / MAX_SENDS) * 100}%`,
                minHeight: 8,
                transition: 'background 0.5s',
                opacity: i <= activeDay ? 1 : 0.4,
              }}
            />
            <span
              style={{
                fontSize: 10, color: '#777',
                fontFamily: "var(--oe-font-mono)",
              }}
            >
              Day {d.day}
            </span>
          </div>
        ))}
      </div>
      <div
        style={{
          display: 'flex', alignItems: 'center', gap: 8,
          padding: '10px 14px', background: '#FFF5ED',
          borderRadius: 10, border: '1px solid rgba(255,107,0,0.15)',
        }}
      >
        <div
          style={{
            width: 8, height: 8, borderRadius: '50%',
            background: '#FF6B00',
            animation: 'oe-pulse 2s infinite',
          }}
        />
        <span
          style={{
            fontSize: 12, color: '#FF6B00', fontWeight: 600,
            fontFamily: "var(--oe-font-mono)",
          }}
        >
          Auto-warming in progress — Day {DAYS[activeDay]?.day}
        </span>
      </div>
    </div>
  )
}
